import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Candidate from "redux/models/candidate";
import LookupTable from "redux/models/lookupTable";
import { selectConfigration } from "redux/slices/configrationSlice";
import { getProfessionalFields } from "config/candidateFields";
import K from "utilities/constants";
import { getIsVisibleLookups } from "utilities/generalUtility";
import { useCandidateSectionContext } from "../../../hooks/useCandidateSectionContext";
import { CandidateFieldsSection } from "../candidateFieldsSection";

const OFFERED_SALARY_DISABLED_STATUSES = new Set([
  K.CandidateStatus.Prospects,
  K.CandidateStatus.Candidates,
  K.CandidateStatus.S2Interview,
  K.CandidateStatus.Submitted,
  K.CandidateStatus.ClientInterview,
]);

export const ProfessionalInfo = ({
  candidateJobEntry,
  setCandidateJobEntry,
  onCandidateChanged,
  isAssignedToJob,
}) => {
  const dispatch = useDispatch();
  const { lookup } = useSelector(selectConfigration);
  const { baseContext } = useCandidateSectionContext(
    candidateJobEntry,
    setCandidateJobEntry,
    onCandidateChanged,
    isAssignedToJob,
  );
  const [availableRecruiters, setAvailableRecruiters] = useState([]);

  useEffect(() => {
    const { URL } = K.Network;
    dispatch(
      LookupTable.getData(
        K.Redux.CandidateStatus,
        URL.Lookup.CandidateStatus,
        [],
        false,
        false,
      ),
    );
    dispatch(
      LookupTable.getData(K.Redux.Source, URL.Lookup.Sources, [], false, false),
    );
  }, [dispatch]);

  useEffect(() => {
    Candidate.getJobRecruiterByJobId(candidateJobEntry.jobsourceId, false)
      .then(setAvailableRecruiters)
      .catch(console.error);
  }, [candidateJobEntry.jobsourceId]);

  const recruiterStateTransform = useCallback(
    (ids) =>
      availableRecruiters
        .filter(({ recruiter }) => ids.includes(recruiter.id))
        .map(({ recruiter }) => ({ id: recruiter.id, name: recruiter.name })),
    [availableRecruiters],
  );

  const candidateStatusOptions = getIsVisibleLookups(
    lookup[K.Redux.CandidateStatus] ?? [],
    candidateJobEntry.candidateStatusesId,
  ).map(({ id, name, isVisible }) => ({
    value: id,
    label: name,
    disabled: isVisible !== 1,
  }));

  const sourceOptions = getIsVisibleLookups(
    lookup[K.Redux.Source] ?? [],
    candidateJobEntry.sourcesId,
  ).map(({ id, name, isVisible }) => ({
    value: id,
    label: name,
    disabled: isVisible !== 1,
  }));

  const context = {
    ...baseContext,
    candidateStatusOptions,
    sourceOptions,
    availableRecruiters,
    recruiterStateTransform,
    isOfferedSalaryDisabled: () =>
      OFFERED_SALARY_DISABLED_STATUSES.has(candidateJobEntry.status?.name),
    isStatusDisabled: () => !baseContext.canEdit,
    isRecruiterOnJob: isAssignedToJob,
  };

  return (
    <CandidateFieldsSection
      title="Additional Details"
      fields={getProfessionalFields()}
      context={context}
    />
  );
};
